import { Input, Textarea } from '@components/undock/forms/input'
import styled from '@emotion/styled'
import { colorGrayscaleBlack, colorGrayscaleDark3 } from '@lib/colors'

export const ContactFormInput = styled(Input)({
  width: '100%',
})

export const ContactFormTextarea = styled(Textarea)({
  minHeight: '10rem',
  width: '100%',
})

export const ContactFormWrapper = styled.form({
  margin: 0,
  padding: 0,
  width: '100%',
})

export const PrivacyLink = styled.a({
  color: colorGrayscaleBlack,
  textDecoration: 'none',
})

export const PrivacyStatement = styled.p({
  color: colorGrayscaleDark3,
  fontSize: '.875rem',
  lineHeight: 1.5,
  margin: 0,
  padding: '0 1rem',
  textAlign: 'center',
})
